import React from "react";

import { useAgentsData } from "../../hooks/use_agents_data";
import { BusMapData } from "../../types/app.types";
import { BusHeatmapChart } from "../BusHeatmapChart/BusHeatmapChart";
import { AgentsLegendCard } from "./AgentsLegendCard";
import { StatisticsCard } from "./StatisticsCard";

interface BusMapContentProps {
  busMapData: BusMapData;
  routeName: string;
}

export const BusMapContent: React.FC<BusMapContentProps> = ({
  busMapData,
  routeName,
}) => {
  const agents = useAgentsData(busMapData);

  return (
    <div className="bus-map-content">
      <div className="chart-container">
        <BusHeatmapChart data={busMapData} route={routeName} />
      </div>

      <div className="info-cards-container">
        <StatisticsCard busMapData={busMapData} />
        <AgentsLegendCard agents={agents} />
      </div>
    </div>
  );
};
